import type { DataTableColumnFilter } from '~/components/DataTable/types'

export const parseCsvFilterValue = (value: string | undefined): string[] =>
  value
    ?.split(',')
    .map((entry) => entry.trim())
    .filter(Boolean) ?? []

const intersectFilterValues = (
  firstValues: string[],
  secondValues: string[]
): string[] => {
  if (firstValues.length === 0) return secondValues
  if (secondValues.length === 0) return firstValues
  return firstValues.filter((value) => secondValues.includes(value))
}

export const setImpossibleResultFilter = (
  queryParams: URLSearchParams,
  paramKey: string
): void => {
  queryParams.set(paramKey, '-1')
}

export type IntersectedFilterResult =
  | { type: 'none' }
  | { type: 'values'; values: string[] }
  | { type: 'impossible' }

type GetIntersectedBarAndColumnFilterParams = {
  barFilters: Record<string, string | undefined>
  barKey: string
  columnFilters: DataTableColumnFilter[]
  columnId: string
}

export const getIntersectedBarAndColumnFilter = ({
  barFilters,
  barKey,
  columnFilters,
  columnId
}: GetIntersectedBarAndColumnFilterParams): IntersectedFilterResult => {
  const barValues = parseCsvFilterValue(barFilters[barKey])
  const columnValue = columnFilters.find(
    (filter) => filter.id === columnId
  )?.value
  const columnValues =
    columnValue !== undefined && columnValue !== null && columnValue !== ''
      ? [String(columnValue)]
      : []
  const values = intersectFilterValues(barValues, columnValues)

  if (barValues.length > 0 && columnValues.length > 0 && values.length === 0) {
    return { type: 'impossible' }
  }
  if (values.length > 0) {
    return { type: 'values', values }
  }
  return { type: 'none' }
}

export const applyIntersectedFilterToQuery = (
  queryParams: URLSearchParams,
  paramKey: string,
  result: IntersectedFilterResult
): boolean => {
  if (result.type === 'impossible') {
    setImpossibleResultFilter(queryParams, paramKey)
    return false
  }
  if (result.type === 'values') {
    queryParams.set(paramKey, result.values.join(','))
  }
  return true
}
